<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full px-gutter flex items-center">
  <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <a *ngIf="isVerticalLayout$ | async"
     [routerLink]="['/']"
     class="ltr:mr-4 rtl:ml-4 block flex items-center">
    <img alt="Logo" class="w-8 select-none" src="assets/img/lrtools_logo.png"/>
  </a>

  <div #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">
    <button *ngIf="isHorizontalLayout$ | async"
            [class.hidden]="mobileQuery"
            (click)="openMegaMenu(megaMenuOriginRef)"
            [ngClass]="{ 'bg-primary/10': megaMenuOpen$ | async }"
            color="primary"
            mat-button
            type="button">
      <span>LR Systems</span>
      <mat-icon class="icon-sm" svgIcon="mat:arrow_drop_down"></mat-icon>
    </button>
  </div>

  <div class="-mx-1 flex items-center justify-center w-full">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix svgIcon="mat:search"></mat-icon>
      <input matInput
              [formControl]="searchCtrl"
              [matAutocomplete]="auto"
              (keydown.enter)="onKeyEnter()"
              placeholder="Search clients, members, contacts and dependents..."
              type="search">
      <mat-progress-spinner matSuffix *ngIf="isLoadingResults" mode="indeterminate" diameter="24"></mat-progress-spinner>
    </mat-form-field>
  </div>

  <div class="ltr:ml-4 rtl:mr-4 flex items-center">
    <vex-toolbar-notifications></vex-toolbar-notifications>
  </div>
</div>

<vex-navigation *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
                [class.hidden]="mobileQuery"></vex-navigation>

<mat-autocomplete #auto="matAutocomplete" style="z-index: 9999;" (optionSelected)="handleOptionSelected($event)">
  <mat-optgroup *ngIf="clientGroups && clientGroups.length > 0" [label]="'Clients'">
    <mat-option *ngFor="let client of clientGroups" [value]="client">
      <span>
        <a href="clients/{{client.masterCCODE}}">{{ client.masterCCODE }} {{client.mName}}</a>
      </span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup *ngIf="clients && clients.length > 0" [label]="'Sub Clients'">
    <mat-option *ngFor="let client of clients" [value]="client">
      <span>
        <a href="clients/{{client.masterCcode}}/subclients/{{client.ccodes}}">{{ client.ccodes }} {{client.cname}}</a>
      </span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup *ngIf="members && members.length > 0" [label]="'Members'">
    <mat-option *ngFor="let member of members" [value]="member">
      <div class="flex items-center">
        <a href="members/detail/{{ member.sub_id }}" class="flex items-center">
          <b class="mr-2">{{ member.sub_id }}</b>
          <span>{{ member.last_name }}, {{ member.first_name }}</span>
          <span 
            *ngIf="member.is_deleted"
            class="bg-red-500 text-white text-xs font-semibold rounded-full px-2 py-0.5 mr-2"
          >
            DELETED
          </span>
        </a>
      </div>
    </mat-option>
  </mat-optgroup>  
  <mat-optgroup *ngIf="contacts && contacts.length > 0" [label]="'Contacts'">
    <mat-option *ngFor="let contact of contacts" [value]="contact">
      <span *ngIf="contact.mCode && !contact.cCode">
        <a href="clients/{{contact.mCode}}/contacts">{{ contact.fullName }} (mcode {{contact.mCode}})</a>
      </span>
      <span *ngIf="contact.mCode && contact.cCode">
        <a href="clients/{{contact.mCode}}/subclients/{{contact.cCode}}/contacts">{{ contact.fullName }} (ccode {{contact.cCode}})</a>
      </span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup *ngIf="dependents && dependents.length > 0" [label]="'Dependents'">
    <mat-option *ngFor="let dependent of dependents" [value]="dependent">
      <span>
        <a href="/members/detail/{{ getMemberDetailId(dependent) }}"> <b>{{ dependent.depRelationship }} </b>{{ dependent.depLastName }},{{ dependent.depFirstName }} </a>
      </span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup *ngIf="lawFirms && lawFirms.length > 0" [label]="'Law Firms'">
    <mat-option *ngFor="let lawFirm of lawFirms" [value]="lawFirm">
      <span>
        <a href="{{ lawFirm.isGroup === true ? 'law-firm-group' : 'law-firm' }}/{{ lawFirm.firmCode }}">
          {{ lawFirm.firmName }} (code {{lawFirm.firmCode}}) 
          <span *ngIf="lawFirm.isGroup === true" class="bg-yellow-200 text-orange-800 text-xs font-medium px-2 py-1 rounded ml-1 mr-1">Group</span>
        </a>
      </span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup *ngIf="lawFirmContacts && lawFirmContacts.length > 0" [label]="'Law Firm Contacts'">
    <mat-option *ngFor="let c of lawFirmContacts" [value]="c">
      <span>
        <a href="law-firm/{{ c.firmCode }}?contact={{ c.contactId }}">
          {{ c.contactName }}<span *ngIf="c.contactRole">, {{ c.contactRole }}</span>, {{ c.firmName }} (code {{ c.firmCode }})
        </a>
      </span>
    </mat-option>
  </mat-optgroup>
</mat-autocomplete>
